// @line/liff 改由 index.html 的 LINE 官方 CDN（固定版路徑）載入，掛在全域 window.liff。
// 經 vite.config.js 的 resolve.alias 把 `import liff from '@line/liff'` 導向本檔，
// 讓 SDK 以全域 window.liff 供應，避免重複載入。
export default window.liff;
